//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import i18n from "../../i18n";
export default {
  data: function data() {
    return {
      language: '',
      selectImg: "https://cdn.vuetifyjs.com/images/flags/cn.png",
      list: [{
        img: "https://cdn.vuetifyjs.com/images/flags/cn.png",
        label: "中文",
        lang: "cn"
      }, {
        img: "https://cdn.vuetifyjs.com/images/flags/us.png",
        label: "English",
        lang: "en"
      }]
    };
  },
  mounted: function mounted() {
    var _lang = localStorage.lang || 'cn';
    this.getLanguage(_lang);
  },
  methods: {
    handleSetLanguage: function handleSetLanguage(item) {
      this.$i18n.locale = item.lang;
      localStorage.setItem('lang', item.lang);
      if (item.lang == "en") {
        // ELEMENT.locale(i18n.locale.lang.en);
      } else if (item.lang == "cn") {
        // ELEMENT.locale(i18n.locale.lang.zhCN);
      } else {
        // ELEMENT.locale(i18n.locale.lang.zhCN);
      }
      this.selectImg = item.img;
      this.getLanguage(item.lang);
    },
    getLanguage: function getLanguage(val) {
      this.$i18n.locale = val;
      localStorage.setItem('lang', val);
      if (val === 'cn') {
        this.language = '中文';
        // ELEMENT.locale(i18n.locale.lang.zhCN);
      }
      if (val === 'en') {
        this.language = 'English';
        // ELEMENT.locale(i18n.locale.lang.en);
      }
      if (val == "") {
        this.language = '中文';
        // ELEMENT.locale(i18n.locale.lang.zhCN);
      }
    }
  }
};